import React, { Component } from 'react';
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader, FormGroup, Label } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import * as Request from '../../service/data-info-chart/requestsUtil';
import { CATALOG_NEW_BUSINESS_ESTATE,
  CATALOG_NEW_BUSINESS_OP_TYPE,
  CATALOG_NEw_BUSINESS_MUN,
  CATALOG_NEW_BUSINESS_PHASE,
} from '../../utils/constants';
import edit from '../../resources/images/estrategas/tools/edit.svg';


class ModalNewBusiness extends Component{
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.saveBusiness = this.saveBusiness.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      modal: false,
      id: null,
      key: 0,
      fasilitator: '',
      estate: '0',
      municipality: '0',
      operationType: '0',
      phase: '0',
      kpi: '',
    }
  }

  componentDidMount(){
    Request.getFetch(CATALOG_NEW_BUSINESS_PHASE).then(resp=>{
      this.cataloguePhase = resp.map(cat =>
        <option value={cat.id} key={cat.name} id={cat.id}>{cat.name}</option>);
    });
    Request.getFetch(CATALOG_NEW_BUSINESS_OP_TYPE).then(resp=>{
      this.catalogueOperationType = resp.map(cat =>
        <option value={cat.id} key={cat.name} id={cat.id}>{cat.name}</option>);
    });
    Request.getFetch(CATALOG_NEW_BUSINESS_ESTATE).then(resp=>{
      this.catalogueEstate = resp.map(cat =>
        <option value={cat.id} key={cat.name} id={cat.id}>{cat.name}</option>);
    });
    Request.getFetch(CATALOG_NEw_BUSINESS_MUN + '1' ).then(resp=>{
      this.catalogueMunicipality = resp.map(cat =>
        <option value={cat.id} key={cat.name} id={cat.id}>{cat.name}</option>);
    });
  }

  createCatalogueMunicipality(){
    Request.getFetch(CATALOG_NEw_BUSINESS_MUN + this.state.id ).then(resp=>{
      this.catalogueMunicipality = resp.map(cat =>
        <option value={cat.id} key={cat.name} id={cat.id}>{cat.name}</option>);
      this.setState({ key: Math.random()});
    });
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    if(name==='estate') {
      this.setState({ [name]: value, id: value }, () => {
        this.createCatalogueMunicipality();
      });
    } else{
      this.setState({ [name]: value });
    }
  }

  saveBusiness() {
    let params = this.props.isUpdate ? {
      'idNewBusiness': this.props.id,
      'fasilitator': this.state.fasilitator,
      'municipality': this.state.municipality,
      'operationType': this.state.operationType,
      'phase': this.state.phase,
      'kpi' : this.state.kpi,
    } :
      {
        'estate': this.state.estate,
        'fasilitator': this.state.fasilitator,
        'municipality': this.state.municipality,
        'operationType': this.state.operationType,
        'phase': this.state.phase,
        'kpi': this.state.kpi
      };
    Request.postFetch(this.props.url, params)
      .then(() => {
        this.toggle();
        this.props.callbackFromParent(Math.random());
      });
  }

  render() {

    let classUser = this.props.authorization ? this.props.className : 'quality-edit-unauthorized';

    return (
      <div>
        <div className={classUser}>
          <img src={edit} title="Editar" alt=" " onClick={this.toggle}/>
        </div>
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader className='header-modal'
                       toggle={this.toggle}>Periodo {this.props.dateModal}</ModalHeader>
          <ModalBody>
            <h2 className='text-center'>{this.props.title}</h2>
            <FormGroup>
              <Label for="facilitador">Facilitador: </Label>
              <Input placeholder="nombre del facilitador" type="text" name="fasilitator" id="fasilitator"
                     value={this.state.fasilitator} onChange={this.handleChange}/>
            </FormGroup>
            <FormGroup>
              <Label for="estate">Estado: </Label>
              <Input
                type="select"
                name="estate"
                id={this.state.estate}
                value={this.state.estate}
                onChange={this.handleChange}>
                <option/>
                {this.catalogueEstate}
              </Input>
            </FormGroup>
            <FormGroup key={this.state.key}>
              <Label for="municipality">Municipio: </Label>
              <Input
                type="select"
                name="municipality"
                id={this.state.municipality}
                value={this.state.municipality}
                onChange={this.handleChange}>
                <option/>
                {this.catalogueMunicipality}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="operationType">Tipo de operación: </Label>
              <Input
                type="select"
                name="operationType"
                id={this.state.operationType}
                value={this.state.operationType}
                onChange={this.handleChange}>
                <option/>
                {this.catalogueOperationType}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="phase">Fase: </Label>
              <Input
                type="select"
                name="phase"
                id={this.state.phase}
                value={this.state.phase}
                onChange={this.handleChange}>
                <option/>
                {this.cataloguePhase}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for='kpi'>Indicadores: </Label>
              <Input placeholder="url del indicador" type="text" name="kpi" id="kpi"
                     value={this.state.kpi} onChange={this.handleChange}/>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.saveBusiness}>Aceptar</Button>{' '}
            <Button color="danger" onClick={this.toggle}>Cancelar</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default ModalNewBusiness;



// WEBPACK FOOTER //
// ./src/components/buttons/modalNewBusiness.js